import {OrganizationConstantValue} from '@models/adminstration/organization/constants/organization-constant-value';

export class OrganizationConstantItem {
  id: number = -1;
  parentId: number = -1;
  settingId: number = -1;
  unit: string = '';
  decimalPlaces: number = -1;
  used: boolean = false;
  constantValues: OrganizationConstantValue[] = new Array<OrganizationConstantValue>();

  constructor() {

  }
}
